module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-dark-sm-8ff3a4aec2eaab31eeaf7d76b1de4aa7.png";